import Immutable from 'immutable';
import store from 'store2';
import { push } from 'react-router-redux';

const LOAD = 'question/LOAD';
const LOAD_SUCCESS = 'question/LOAD_SUCCESS';
const LOAD_FAIL = 'question/LOAD_FAIL';

const initialState = Immutable.fromJS({
  Questions: null,
  loading: false,
  errorMessage: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('loading', true)

    case LOAD_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
      return state
        .set('loading', false)
        .set('Questions', action.Questions);

    default:
      return state;
  }
}

export const getCampaignQuestion = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/campaign/question/all/'+id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, Questions: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/question.js